import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { mediaUrl } from "../lib/api";
import { useAudio } from "../store/audio";

const LINKS = [
  ["univers", "Univers"],
  ["experiences", "Expériences"],
  ["evenements", "Événements"],
  ["sound", "Sound"],
  ["collaborateurs", "Artistes"],
  ["collaborer", "Collaborer"],
  ["contact", "Contact"],
];

export const Nav = ({ brand = "EFFERVESCENCE", logo = "", tracks = [] }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const playList = useAudio((s) => s.playList);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpenMenu(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  const listen = () => {
    if (tracks.length) playList(tracks, 0);
    go("sound");
  };

  return (
    <header className={`sticky top-0 z-40 transition-colors duration-500 ${scrolled ? "bg-[#080808]/95 backdrop-blur-md" : "bg-[#080808]"}`}>
      <div className="max-w-[1180px] mx-auto px-7">
        <nav className="h-[86px] border-b eff-line flex items-center justify-between">
          <button data-testid="nav-brand" onClick={() => go("hero")} className="flex items-center">
            {logo ? (
              <img src={mediaUrl(logo)} alt={brand} className="h-[54px] w-auto block mix-blend-screen" />
            ) : (
              <span className="font-display text-xl tracking-wide">{brand}</span>
            )}
          </button>
          <div className="hidden md:flex items-center">
            {LINKS.map(([id, label]) => (
              <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)}
                className="eff-nav-link ml-7 hover:text-white transition-colors duration-300">
                {label}
              </button>
            ))}
            <a href="/access" data-testid="nav-access" className="eff-nav-link ml-7 hover:text-white transition-colors duration-300">Access</a>
            <button data-testid="nav-listen" onClick={listen} className="eff-nav-link ml-7 border border-[#777] px-4 py-2 hover:border-white transition-colors duration-300">
              Listen
            </button>
          </div>
          <button data-testid="nav-menu-toggle" className="md:hidden" onClick={() => setOpenMenu((v) => !v)}>
            {openMenu ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </nav>
      </div>
      {openMenu && (
        <div className="md:hidden border-b eff-line bg-[#080808]">
          <div className="max-w-[1180px] mx-auto px-7 py-6 flex flex-col gap-5">
            {LINKS.map(([id, label]) => (
              <button key={id} data-testid={`nav-mobile-${id}`} onClick={() => go(id)} className="eff-nav-link text-left">
                {label}
              </button>
            ))}
            <button data-testid="nav-listen-mobile" onClick={listen} className="eff-nav-link text-left">Listen</button>
            <a href="/access" data-testid="nav-access-mobile" className="eff-nav-link text-left">Access</a>
          </div>
        </div>
      )}
    </header>
  );
};
